import { __decorate, __param } from 'tslib';
import { EventEmitter, Inject, Input, HostBinding, Output, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { tuiDefaultProp } from '@taiga-ui/cdk';
import { TUI_CLOSE_WORD, TUI_NOTIFICATION_OPTIONS } from '@taiga-ui/core/tokens';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TuiButtonModule } from '@taiga-ui/core/components/button';
import { TuiSvgModule } from '@taiga-ui/core/components/svg';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@taiga-ui/core/components/svg';
import * as ɵngcc3 from '@taiga-ui/core/components/button';
import * as ɵngcc4 from 'rxjs';

function TuiNotificationComponent_tui_svg_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tui-svg", 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r0.icon);
} }
function TuiNotificationComponent_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4);
    ɵngcc0.ɵɵlistener("click", function TuiNotificationComponent_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.close.emit(); });
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(1, 1, ctx_r1.closeWord$));
} }
const _c0 = ["*"];
const STATUS_ICON = {
    info: 'tuiIconInfo',
    success: 'tuiIconCheckCircle',
    error: 'tuiIconCancel',
    warning: 'tuiIconAttention',
};
// @bad TODO: Think about moving to kit
let TuiNotificationComponent = class TuiNotificationComponent {
    constructor(closeWord$, options) {
        this.closeWord$ = closeWord$;
        this.options = options;
        this.hasIcon = this.options.hasIcon;
        this.status = this.options.status;
        this.close = new EventEmitter();
    }
    get icon() {
        return STATUS_ICON[this.status];
    }
    get hasClose() {
        return !!this.close.observers.length;
    }
};
TuiNotificationComponent.ɵfac = function TuiNotificationComponent_Factory(t) { return new (t || TuiNotificationComponent)(ɵngcc0.ɵɵdirectiveInject(TUI_CLOSE_WORD), ɵngcc0.ɵɵdirectiveInject(TUI_NOTIFICATION_OPTIONS)); };
TuiNotificationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiNotificationComponent, selectors: [["tui-notification"]], hostVars: 5, hostBindings: function TuiNotificationComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-tui-host-status", ctx.status);
        ɵngcc0.ɵɵclassProp("_has-icon", ctx.hasIcon)("_has-close-button", ctx.hasClose);
    } }, inputs: { hasIcon: "hasIcon", status: "status" }, outputs: { close: "close" }, ngContentSelectors: _c0, decls: 4, vars: 2, consts: [["automation-id", "tui-notification__icon", "class", "icon", 3, "src", 4, "ngIf"], [1, "content"], ["tuiIconButton", "", "type", "button", "automation-id", "tui-notification__close", "size", "xs", "icon", "tuiIconCloseLarge", "appearance", "icon", "class", "close", 3, "title", "click", 4, "ngIf"], ["automation-id", "tui-notification__icon", 1, "icon", 3, "src"], ["tuiIconButton", "", "type", "button", "automation-id", "tui-notification__close", "size", "xs", "icon", "tuiIconCloseLarge", "appearance", "icon", 1, "close", 3, "title", "click"]], template: function TuiNotificationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TuiNotificationComponent_tui_svg_0_Template, 1, 1, "tui-svg", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, TuiNotificationComponent_button_3_Template, 2, 3, "button", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasIcon);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasClose);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.TuiSvgComponent, ɵngcc3.TuiButtonComponent], pipes: [ɵngcc1.AsyncPipe], styles: ["[_nghost-%COMP%]{font:var(--tui-font-text-s);color:var(--tui-text-01);position:relative;display:block;padding:.8125rem 1rem .6875rem;border-radius:var(--tui-radius-m);background:#fff;background:var(--tui-base-01);box-sizing:border-box;overflow:hidden}[_nghost-%COMP%]:after{position:absolute;top:0;left:0;width:100%;height:100%;content:'';pointer-events:none}._has-close-button[_nghost-%COMP%]{padding-right:2rem}._has-icon[_nghost-%COMP%]{padding-left:2.75rem}[data-tui-host-status=info][_nghost-%COMP%]{color:var(--tui-info-fill)}[data-tui-host-status=info][_nghost-%COMP%]:after{background:var(--tui-info-bg)}[data-tui-host-status=success][_nghost-%COMP%]{color:var(--tui-success-fill)}[data-tui-host-status=success][_nghost-%COMP%]:after{background:var(--tui-success-bg)}[data-tui-host-status=error][_nghost-%COMP%]{color:var(--tui-error-fill)}[data-tui-host-status=error][_nghost-%COMP%]:after{background:var(--tui-error-bg)}[data-tui-host-status=warning][_nghost-%COMP%]{color:var(--tui-warning-fill)}[data-tui-host-status=warning][_nghost-%COMP%]:after{background:var(--tui-warning-bg)}.content[_ngcontent-%COMP%]{word-wrap:break-word;color:var(--tui-text-01)}.icon[_ngcontent-%COMP%]{position:absolute;top:0;left:1rem;display:flex;width:1rem;height:100%;max-height:3rem;align-items:center}.close[_ngcontent-%COMP%]{position:absolute;top:.625rem;right:.5rem}"], changeDetection: 0 });
TuiNotificationComponent.ctorParameters = () => [
    { type: Observable, decorators: [{ type: Inject, args: [TUI_CLOSE_WORD,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_NOTIFICATION_OPTIONS,] }] }
];
__decorate([
    Input(),
    HostBinding('class._has-icon'),
    tuiDefaultProp()
], TuiNotificationComponent.prototype, "hasIcon", void 0);
__decorate([
    Input(),
    HostBinding('attr.data-tui-host-status'),
    tuiDefaultProp()
], TuiNotificationComponent.prototype, "status", void 0);
__decorate([
    Output()
], TuiNotificationComponent.prototype, "close", void 0);
__decorate([
    HostBinding('class._has-close-button')
], TuiNotificationComponent.prototype, "hasClose", null);
TuiNotificationComponent = __decorate([ __param(0, Inject(TUI_CLOSE_WORD)),
    __param(1, Inject(TUI_NOTIFICATION_OPTIONS))
], TuiNotificationComponent);

let TuiNotificationModule = class TuiNotificationModule {
};
TuiNotificationModule.ɵfac = function TuiNotificationModule_Factory(t) { return new (t || TuiNotificationModule)(); };
TuiNotificationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiNotificationModule });
TuiNotificationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, TuiSvgModule, TuiButtonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiNotificationComponent, [{
        type: Component,
        args: [{
                selector: 'tui-notification',
                template: "<tui-svg\n    *ngIf=\"hasIcon\"\n    automation-id=\"tui-notification__icon\"\n    class=\"icon\"\n    [src]=\"icon\"\n></tui-svg>\n<div class=\"content\">\n    <ng-content></ng-content>\n</div>\n<button\n    *ngIf=\"hasClose\"\n    tuiIconButton\n    type=\"button\"\n    automation-id=\"tui-notification__close\"\n    size=\"xs\"\n    icon=\"tuiIconCloseLarge\"\n    appearance=\"icon\"\n    class=\"close\"\n    [title]=\"closeWord$ | async\"\n    (click)=\"close.emit()\"\n></button>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{font:var(--tui-font-text-s);color:var(--tui-text-01);position:relative;display:block;padding:.8125rem 1rem .6875rem;border-radius:var(--tui-radius-m);background:#fff;background:var(--tui-base-01);box-sizing:border-box;overflow:hidden}:host:after{position:absolute;top:0;left:0;width:100%;height:100%;content:'';pointer-events:none}:host._has-close-button{padding-right:2rem}:host._has-icon{padding-left:2.75rem}:host[data-tui-host-status=info]{color:var(--tui-info-fill)}:host[data-tui-host-status=info]:after{background:var(--tui-info-bg)}:host[data-tui-host-status=success]{color:var(--tui-success-fill)}:host[data-tui-host-status=success]:after{background:var(--tui-success-bg)}:host[data-tui-host-status=error]{color:var(--tui-error-fill)}:host[data-tui-host-status=error]:after{background:var(--tui-error-bg)}:host[data-tui-host-status=warning]{color:var(--tui-warning-fill)}:host[data-tui-host-status=warning]:after{background:var(--tui-warning-bg)}.content{word-wrap:break-word;color:var(--tui-text-01)}.icon{position:absolute;top:0;left:1rem;display:flex;width:1rem;height:100%;max-height:3rem;align-items:center}.close{position:absolute;top:.625rem;right:.5rem}"]
            }]
    }], function () { return [{ type: ɵngcc4.Observable, decorators: [{
                type: Inject,
                args: [TUI_CLOSE_WORD]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_NOTIFICATION_OPTIONS]
            }] }]; }, { hasIcon: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class._has-icon']
        }], status: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.data-tui-host-status']
        }], close: [{
            type: Output
        }], hasClose: [{
            type: HostBinding,
            args: ['class._has-close-button']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiNotificationModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TuiSvgModule, TuiButtonModule],
                declarations: [TuiNotificationComponent],
                exports: [TuiNotificationComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiNotificationModule, { declarations: function () { return [TuiNotificationComponent]; }, imports: function () { return [CommonModule, TuiSvgModule, TuiButtonModule]; }, exports: function () { return [TuiNotificationComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { STATUS_ICON, TuiNotificationComponent, TuiNotificationModule };

